import { render, staticRenderFns } from "./AppIcon.vue?vue&type=template&id=5071a442&"
import script from "./AppIcon.js?vue&type=script&lang=js&"
export * from "./AppIcon.js?vue&type=script&lang=js&"
import style0 from "./AppIcon.scss?vue&type=style&index=0&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports